var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{'positive': _vm.secs > 0, 'non-positive': _vm.secs <= 0}},[_vm._v(_vm._s(_vm.secs))])}
var staticRenderFns = []

export { render, staticRenderFns }